export const CAT_CONTENT_FETCHED = 'CAT_CONTENT_FETCHED';
export const FLOW_CONTENT_COMPLETED = 'FLOW_CONTENT_COMPLETED';
export const FLOW_INPUT_COMPLETED = 'FLOW_INPUT_COMPLETED';
export const FLOW_LOADED = 'FLOW_LOADED';
export const FLOW_PAGE_COMPLETED = 'FLOW_PAGE_COMPLETED';
export const FLOW_QUESTION_COMPLETED = 'FLOW_QUESTION_COMPLETED';
export const GOTO_NODE = 'GOTO_NODE';
export const INPUT_CHANGED = 'INPUT_CHANGED';
export const INPUT_REGISTRATION_COMPLETED = 'INPUT_REGISTRATION_COMPLETED';
export const INPUT_VALIDATION_FAILED = 'INPUT_VALIDATION_FAILED';
